import React, { useState, useEffect } from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import { RequestPage } from '@mui/icons-material';
import EditReportModule from './EditReportModule';
import EditMonthReportModule from './EditMonthReportModule';
// import EditReportModuleNEW from './EditReportModuleNEW';
import ViewReportModule from './ViewReportModule';
import ViewReportModuleDir from './ViewReportModuleDir';
import UsersPerDay from './CheckUsersOnDay';
import Compare from './CompareModule';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import TableChartIcon from '@mui/icons-material/TableChart';

type ModuleType = 'edit' | 'editnew' | 'view' | 'empty' | 'compare' | 'MathReport' | 'editmonth';

interface ReportsProps {
  setSelectedIndex: (index: number) => void;
  selectedModule?: ModuleType;
}

const Reports: React.FC<ReportsProps> = ({ setSelectedIndex, selectedModule }) => {
  const role = localStorage.getItem('role');
  const isView = role === 'view';
  const isFullReport = role === 'full-report';
  const isAdmin = role === 'admin';

  const getInitialModule = (): ModuleType => {
    if (isView) return 'editnew';
    if (isFullReport) return 'empty';
    return 'edit';
  };

  const [activeModule, setActiveModule] = useState<ModuleType | null>(selectedModule || getInitialModule());

  useEffect(() => {
    if (selectedModule) {
      setActiveModule(selectedModule);
    }
  }, [selectedModule]);

  const handleMathReportClick = () => {
    setSelectedIndex(6);
  };

  return (
    <Box sx={{ maxWidth: '100%', overflowX: 'auto' }}>

      <Box sx={{ mb: 2, display: 'flex', gap: '10px' }}>
        <Tooltip title="Показать пользователей за день" enterDelay={1000} arrow>
          <Button
            variant="contained"
            onClick={() => setActiveModule('empty')}
            startIcon={<PermContactCalendarIcon />}
          >
            Заполнение
          </Button>
        </Tooltip>

        {!isView && !isFullReport && (
          <Tooltip title="Редактировать отчет" enterDelay={1000} arrow>
            <Button
              variant="contained"
              onClick={() => setActiveModule('edit')}
              color="warning"
              disabled={isView}
              startIcon={<DriveFileRenameOutlineIcon />}
            >
              Редактировать
            </Button>
          </Tooltip>
        )}

        {!isView && !isFullReport && (
          <Tooltip title="Редактирование отчёта за месяц" enterDelay={1000} arrow>
            <Button
              variant="contained"
              onClick={() => setActiveModule('editmonth')}
              sx={{ background: 'orange', color: 'white' }}
            >
              Редактирование (мес)
            </Button>
          </Tooltip>
        )}

        {(!isView || isAdmin || isFullReport) && (
          <Tooltip title="Просмотреть отчет" enterDelay={1000} arrow>
            <Button
              variant="contained"
              onClick={() => setActiveModule('view')}
              color="secondary"
              startIcon={<DescriptionIcon />}
            >
              Отчет
            </Button>
          </Tooltip>
        )}

        {(isView || isAdmin) && !isFullReport && (
          <Tooltip title="Просмотреть отчет (DO)" enterDelay={1000} arrow>
            <Button
              variant="contained"
              onClick={() => setActiveModule('editnew')}
              color="secondary"
              startIcon={<DescriptionIcon />}
            >
              дир Отчет
            </Button>
          </Tooltip>
        )}

        <Tooltip title="Сопоставление Excel файлов" enterDelay={1000} arrow>
          <Button
            variant="contained"
            onClick={() => setActiveModule('compare')}
            sx={{ background: 'green', color: 'white' }}
            startIcon={<TableChartIcon />}
          >
            Доставка
          </Button>
        </Tooltip>

        {!isView && !isFullReport && (
          <Tooltip title="Материальный отчет" enterDelay={1000} arrow>
            <Button
              variant="contained"
              onClick={handleMathReportClick}
              sx={{ background: 'darkblue', color: 'white' }}
              startIcon={<RequestPage />}
            >
              Мат отчет
            </Button>
          </Tooltip>
        )}
      </Box>


      {activeModule === 'empty' && <UsersPerDay />}
      {activeModule === 'edit' && <EditReportModule />}
      {activeModule === 'editnew' && <ViewReportModuleDir />}
      {activeModule === 'view' && <ViewReportModule />}
      {activeModule === 'compare' && <Compare />}
      {activeModule === 'editmonth' && <EditMonthReportModule />}


    </Box>
  );
};

export default Reports;